<template>
  <div class="mt-4 px-5">
    <h2>Waffenpool</h2>

    <v-alert dense type="info" class="mt-4">
      Hier siehst du alle Waffen, die dein Verein und andere Mitglieder zur Verfügung stellen.
    </v-alert>

    <!-- Filter Card -->
    <v-card class="mt-4 mb-4">
      <v-card-title>Filter</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="filters.kaliber"
              :items="availableKaliber"
              label="Kaliber"
              clearable
              outlined
              dense
              @change="applyFilters"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-model="filters.gattung"
              :items="availableGattungen"
              label="Gattung"
              clearable
              outlined
              dense
              @change="applyFilters"
            ></v-select>
          </v-col>
<!--          <v-col cols="12" sm="6" md="3">-->
<!--            <v-select-->
<!--              v-model="filters.discipline_id"-->
<!--              :items="disciplines"-->
<!--              item-text="name"-->
<!--              item-value="id"-->
<!--              label="Disziplin"-->
<!--              clearable-->
<!--              outlined-->
<!--              dense-->
<!--              @change="applyFilters"-->
<!--            ></v-select>-->
<!--          </v-col>-->
<!--          <v-col cols="12" sm="6" md="3">-->
<!--            <v-select-->
<!--              v-model="filters.beduerfnis"-->
<!--              :items="beduerfnisOptions"-->
<!--              item-text="text"-->
<!--              item-value="value"-->
<!--              label="Bedürfnis"-->
<!--              clearable-->
<!--              outlined-->
<!--              dense-->
<!--              @change="applyFilters"-->
<!--            ></v-select>-->
<!--          </v-col>-->
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Data Table -->
    <v-data-table
      :headers="headers"
      :items="comp_PoolWeapons"
      class="elevation-1"
      :items-per-page="15"
    >
      <template v-slot:top>
        <v-toolbar flat color="success">
          <v-toolbar-title>Verfügbare Pool-Waffen</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="refreshData">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.weapon_info="{ item }">
        <div>
          <strong>{{ item.weapon.hersteller }} {{ item.weapon.kurz_bezeichnung }}</strong>
          <br>
          <span class="text-caption">{{ item.weapon.kaliber }} | {{ item.weapon.gattung }}</span>
        </div>
      </template>

      <template v-slot:item.owner="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              small
              :color="item.owner_type === 'club' ? 'blue' : 'purple'"
              text-color="white"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left small>
                {{
                  item.owner_type === "club"
                    ? "mdi-domain"
                    : "mdi-account"
                }}
              </v-icon>
              {{ item.owner_name }}
            </v-chip>
          </template>
          <span>
            <strong>Besitzer:</strong> {{ item.owner_name }}<br />
            <strong>Typ:</strong>
            {{
              item.owner_type === "club"
                ? "Vereinswaffe"
                : "Mitgliederwaffe"
            }}<br />
            <span v-if="item.notes"
              ><strong>Hinweise:</strong> {{ item.notes }}</span
            >
          </span>
        </v-tooltip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          small
          @click="useForTraining(item)"
        >
          <v-icon left small>mdi-book-open-variant</v-icon>
          Für Training nutzen
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "weaponpool",
  data: () => ({
    filters: {
      kaliber: null,
      gattung: null,
      discipline_id: null,
      beduerfnis: null
    },
    headers: [
      { text: 'Waffe', value: 'weapon_info', sortable: false },
      { text: 'Besitzer', value: 'owner', sortable: false },
      { text: 'Hinweise', value: 'notes', sortable: false },
      { text: 'Aktionen', value: 'actions', sortable: false, align: 'center' }
    ],
    beduerfnisOptions: [
      { value: 'sport', text: 'Sportschütze' },
      { value: 'jagd', text: 'Jäger' },
      { value: 'sammler', text: 'Sammler' },
      { value: 'hersteller', text: 'Händler' },
      { value: 'gefaehrdet', text: 'Gefährdete Person' }
    ]
  }),

  computed: {
    comp_PoolWeapons() {
      return this.$store.getters['UserApp/weaponPool'];
    },
    disciplines() {
      return this.$store.state.UserApp.Discipline || [];
    },
    availableKaliber() {
      const weapons = this.comp_PoolWeapons.map(w => w.weapon.kaliber);
      return [...new Set(weapons)];
    },
    availableGattungen() {
      const weapons = this.comp_PoolWeapons.map(w => w.weapon.gattung);
      return [...new Set(weapons)];
    }
  },

  mounted() {
    this.$store.dispatch('UserApp/ensureDisciplines');
    this.loadData();
  },

  methods: {
    async loadData() {
      await this.$store.dispatch('UserApp/fetchPoolWeapons');
    },
    refreshData() {
      this.loadData();
    },
    applyFilters() {
      this.$store.dispatch('UserApp/fetchPoolWeapons', this.filters);
    },
    useForTraining(poolWeapon) {
      this.$router.push({
        path: '/user/recordtime',
        query: { weapon_pool_id: poolWeapon.id }
      });
    }
  }
}
</script>
